import * as React from 'react';
import * as _ from 'lodash'
import config from '../../../../constants/config';
import {  AxiosInstance } from '../../../../utils/RequestMethods';
import { workerIsExistsInCrew } from '../Job';

import { Card, Image } from 'react-bootstrap';
import ButtonLoading from '../../../../components/ButtonLoading/ButtonLoading';
import images from '../../../../constants/images';
import { CrewProspectsLineItemT, JobT } from '../../../../types/Job';
import instanceSocketClient from '../../../../service/InstanceSocketClient';


const style = {
  textDisplayName: {
    flex: 1, justifyContent: "center", alignSelf: 'center', margin: 2, padding: 5
  }
}


export type ICrewProspectsProps = {
  job: JobT
}

/**
 *
 */


const CrewProspects: React.FC<ICrewProspectsProps> = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  // const [crewProspects, setCrewProspects] = React.useState(initCrewProspects);
  const [currentJob, setCurrentJob] = React.useState(null)
  const [items, setItems] = React.useState([]);
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    listenSocket()
  }, []);
  React.useEffect(() => {
    if (!_.isEqual(currentJob, props.job)) {
      fetchData()
      setCurrentJob(props.job)
    }

  }, [props.job])


  const listenSocket = () => {
    const event = `update-jobs-${props.job.id}`
    instanceSocketClient.on(event, (args) => {
      console.log("socket->CrewProspects", args)
      fetchData()
    })
  }
  /**
   *
   */
  const fetchDataSilent = async () => {
    return await AxiosInstance.get(`${config.url.jobs}/${props.job.id}/crew-prospects`)
  }

  /**
   *
   */
  const fetchData = async () => {
    setIsLoading(true)
    fetchDataSilent().then((res) => {
      setIsLoading(false)
      if (res && res.data) {
        setItems(res.data)
      }
    }).catch((error) => {
      setIsLoading(false)
    })
  }

  /**
   *
   * @param item
   */
  const updateStatus = async (item: CrewProspectsLineItemT, status: 'approved' | 'rejected') => {
    const params = {
      'status': status

    }
    return AxiosInstance.post(`${config.url.jobs}/${props.job.id}/crew-prospects/${item.workerId}`, params).then((res) => {
      if (res && res.data) {
        setTimeout(() => {
          fetchDataSilent()
        }, 1);
      }
      return `Worker ${_.capitalize(status)}.`;
    })
  }

  /**
   *
   * @returns
   */
  const getDisplayItems = (items): Array<CrewProspectsLineItemT> => {
    return items.filter((item) => (item.status == "approved" || workerIsExistsInCrew(props.job, item.workerId)) == false)
  }


  return (
    <div className="mt-2">
      {getDisplayItems(items).length > 0 && <h3>Prospects</h3>}
      {items.map((item: CrewProspectsLineItemT, index) => {
        if (item.status == 'approved' || workerIsExistsInCrew(props.job, item.workerId)) {
          return null;
        }
        return (
          <div key={index}>
            <Card style={{ backgroundColor: `${(item.status == 'rejected' || item.status == 'removedBySelf') ? "#ff3547" : "#fff"}` }}>
              <Card.Body>
                <div className="d-flex flex-row">
                  <div className="d-flex p-2 flex-fill">
                    <Image roundedCircle
                      style={{ width: 60, height: 60 }}
                      src={item.worker && item.worker.profilePic ? `${item.worker.profilePic}` : images.noProfilePic} />
                    {item.worker &&
                      <span style={style.textDisplayName}>
                        {item.worker.firstName} {item.worker.lastName}
                      </span>}

                  </div>
                  <div className="p-2 d-flex flex-row">

                    {(item.status == 'pending' || item.status == 'rejected') &&
                      <ButtonLoading variant="success"
                        onClickFetching={async () => {
                          return await updateStatus(item, 'approved')
                        }}>
                        <i className="fa fa-check" />
                        <span style={{ color: "#fff" }}> Approve</span>
                      </ButtonLoading>}

                    {(item.status == 'pending') &&
                      <ButtonLoading variant="danger" onClickFetching={async () => {
                        return await updateStatus(item, 'rejected')
                      }}>
                        <i className="fa fa-ban " />
                        <span style={{ color: "#fff" }}> Reject</span>
                      </ButtonLoading>}

                  </div>

                </div>
              </Card.Body>
            </Card>

          </div>
        )
      })}
    </div>
  );
}

export default CrewProspects;
export { CrewProspects };
